import type { GetMeResponse } from '@/shared/generated/graphql';
import { Store } from '@tanstack/store';

export const userStore = new Store<GetMeResponse | null>(null);

export const setUserStore = (user: GetMeResponse | null) => {
  userStore.setState(user);
};

export const getUserStore = () => userStore.state;
